// 操作、修改、新建等http请求
// import Http from '../../api/http'
// const Http = window.a.api;

/*
* handlerChargeItemHttp:function(){
        let self = this
        let params={
        }
        self.$showViewLoading()
        a.api('/axinsf/yskzx/saveZx',params).then(data => {
          self.$closeViewLoading()
          self.$showSuccessMsg(constant.successPromptTotal.handlerPrompt)
        }).catch(e => {
          self.$closeViewLoading()
          self.$showFailureMsg(e.message)
        })
      },
* */

export default {
	// 删除
	/*
	 * operationHTTP.deleteHttp('/axinsf/cuszy/delete', _params, this,'getLoadData', 'datagrid')
	 * */
	deleteHttp(url, params = {}, self, refreshCallback = 'getLoadData', refDataGrid = 'datagrid') {
		const _params = params;
		const _ref = refDataGrid;
		self.$showViewLoading();
		a.api('auditLogRequest', {
			..._params,
			url,
		})
			.then((data) => {
				self.$closeViewLoading();
				self.$showSuccessMsg('删除成功！');
				self.$refs[_ref].$emit('refresh');
				self[refreshCallback]();
			})
			.catch((e) => {
				self.$closeViewLoading();
				self.$showFailureMsg(e.message);
			});
	},
	// 添加
	/*
	 * operationHTTP.AddHttp('/axinsf/cuszy/add', _params, this,'getLoadData', 'campusAdd', 'datagrid')，campusAdd为控制弹窗显示隐藏的变量
	 * */
	AddHttp(url, params = {}, self, refreshCallback = 'getLoadData', dialogShow, refDataGrid = 'datagrid') {
		const _params = params;
		// let _ref = refDataGrid
		const _dialogShow = dialogShow;
		self.$showViewLoading();
		a.api('auditLogRequest', { ..._params, url })
			.then((data) => {
				self.$closeViewLoading();
				// self.$refs[_ref].filterClear()
				self[refreshCallback]();
				self.$showSuccessMsg('添加成功！');
				self[_dialogShow] = false;
			})
			.catch((e) => {
				self.$closeViewLoading();
				self.$showFailureMsg(e.message);
			});
	},
	// 编辑
	/*
	 * operationHTTP.editHttp('/axinsf/cuszy/update', _params, this, 'campusAdd','datagrid')，campusAdd为控制弹窗显示隐藏的变量
	 * */
	editHttp(url, params = {}, self, refreshCallback = 'getLoadData', dialogShow, refDataGrid = 'datagrid') {
		const _params = params;
		// let _ref = refDataGrid
		const _dialogShow = dialogShow;
		self.$showViewLoading();
		a.api('auditLogRequest', { ..._params, url })
			.then((data) => {
				self.$closeViewLoading();
				// self.$refs[_ref].filterClear()
				self[refreshCallback]();
				self.$showSuccessMsg('修改成功！');
				self[_dialogShow] = false;
			})
			.catch((e) => {
				self.$closeViewLoading();
				self.$showFailureMsg(e.message);
			});
	},
	// 操作
	/*
	 * operationHTTP.otherOperationHttp('/axinsf/cuszy/update', _params, this,'getLoadData' 'datagrid')
	 * */
	otherOperationHttp(url, params = {}, self, refreshCallback = 'getLoadData', refDataGrid = 'datagrid') {
		const _params = params;
		// let _ref = refDataGrid
		self.$showViewLoading();
		a.api('auditLogRequest', { ..._params, url })
			.then((data) => {
				self.$closeViewLoading();
				// self.$refs[_ref].filterClear()
				self[refreshCallback]();
				self.$showSuccessMsg('操作成功！');
			})
			.catch((e) => {
				self.$closeViewLoading();
				self.$showFailureMsg(e.message);
			});
	},
	// 页面有数据绑定的http
	/*
  * operationHTTP.getDataToPageHttp('/upms-sys/sysdicitem/findListCon', _params, _self).then(data => {
      let _data = data.resp_data
      _self[_pageData] = []
      if (Array.isArray(_data)) {
        _data.forEach(item => {
          _self[_pageData].push({label: item.item_name, value: item.item_code})
        })
        // return returnArr
      }
    })
  * */
	getDataToPageHttp(url, params = {}, self, refDataGrid = 'datagrid') {
		const _params = params;
		console.log(url);
		// let _ref = refDataGrid
		self.$showViewLoading();
		return new Promise(((resolve, reject) => {
			a.api('auditLogRequest', { ..._params, url: `/upms-sys/sysdicitem/${url}` })
				.then((data) => {
					self.$closeViewLoading();
					resolve(data);
				})
				.catch((e) => {
					self.$closeViewLoading();
					self.$showFailureMsg(e.message);
					reject(e);
			});
		}));
	},
	// table数据
	/*
  * operationHTTP.getTableDataToPageHttp('/axinsf/cuszy/findList', _params, this, 'bgData', 'totalCount').then(data => {
          self.bgData = data.resp_data.list
          self.totalCount = data.resp_data.total
        })
  * */
	getTableDataToPageHttp(url, params = {}, self, tableKey = 'bgData', totalCount = 'totalCount', refDataGrid = 'datagrid') {
		const _params = params;
		// let _ref = refDataGrid
		self.$showViewLoading();
		return new Promise(((resolve, reject) => {
			a.api('auditLogRequest', { ..._params, url })
				.then((data) => {
					self.$closeViewLoading();
					resolve(data);
				})
				.catch((e) => {
					self.$closeViewLoading();
					self.$showFailureMsg(e.message);
					self[tableKey] = [];
					self[totalCount] = 0;
			});
		}));
	},
	/* 获取配置信息 */
	getClientConfHttp() {
		const data = require('../../../config/epay.json');
		return new Promise(((resolve, reject) => {
			if (data) {
				resolve(data);
			} else {
				reject('获取配置文件失败');
			}
		}));
	},
};
